<template>
  <div class="coupon-detail">
    <div class="head">
      <img class="head-img" :src="cardInfo.card_pic" alt="">
    </div>
    <div class="card-text">
      <h3 class="card-name">{{ cardInfo.card_name }}</h3>
      <div>卡券有效日期: {{ cardInfo.exp_time }}</div>
      <div v-if="cardInfo.state === 1">有效期: {{ expirationDate }} 个月</div>
      <div  v-else>使用时间: {{ cardInfo.use_time }} </div>
    </div>
    <div class="card-secret-num">
      <div class="card-num">卡密: <span :class="showNumber ? 'text-show' : ''"> {{ cardNumber }}</span> </div>
      <div class="copy" @click="copyNumber">| {{ showNumber ? "复制" : "查看" }}</div>
    </div>
    <div class="use-btn-wrap">
      <van-button class="use-btn" @click="routerTo" round color="#F5DCAD">立即使用</van-button>
    </div>
    <div class="instructions" v-html="cardInfo.card_detail"></div>
  </div>
</template>
<script>
import { cardDetailApi } from '@/api/card';
import { Button } from 'vant';

export default {
 components: {
    [Button.name]: Button
  },
  data () {
    return {
      cardInfo: {
        card_token: ''
      },
      showNumber: false
    }
  },
  computed: {
    cardNumber () {
      const { card_code = '' } = this.cardInfo
      return this.showNumber ? card_code : card_code.replace(/./g, 'X')
    },
    expirationDate () {
      const date = new Date(this.cardInfo.exp_time)
      const now = new Date()
      const expiraMonth = date.getMonth() + 1
      const nowMonth = now.getMonth() + 1
      // 剩余多少个月
      const surplus = expiraMonth - nowMonth
      return surplus ? surplus : 0
    }
  },
  methods: {
    // 获取卡券信息
    async getCardInfo () {
      const cardId = this.$route.query['c_id']
      const result = await cardDetailApi({
        id: cardId
      })
      const { status = false, detail= {} } = result.data.data
      if (status) {
        this.cardInfo = detail
      }
    },
    // 复制卡密
    copyNumber () {
      if (!this.showNumber) {
        this.showNumber = true
        return
      }

      let textarea = document.createElement('textarea');
			textarea.style.position = 'fixed';
			textarea.style.opacity = 0;
			textarea.value = this.cardInfo.card_code;
			document.body.appendChild(textarea);
			textarea.select();
			document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$toast('复制成功')
    },
    // 路由跳转
    routerTo () {
      window.open(this.cardInfo.use_url, '_blank');
      // this.$router.go(this.cardInfo.use_url)
    }
  },
  created() {
    this.getCardInfo()
  },
}
</script>
<style scoped>
.coupon-detail{
  background: url('~@/assets/exchange/exchange-bg.png') 100%/100% no-repeat;
  min-height: 100vh;
  font-size: 0.24rem;
}

.head {
  height: 2.68rem;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
}

.head .head-img {
  width: 1.6rem;
  height: 1.6rem;
}

.card-text{
  text-align: left;
  width: 6.86rem;
  margin: 0 auto;
  font-size: 0.28rem;
  padding-bottom: 0.2rem;
  margin-bottom: 0.1rem;
  border-bottom: 1px dashed #8d8d8dee;
}

.card-text .card-name {
  font-size: 0.32rem;
  margin: 0.08rem 0;
}

.card-secret-num{
  display: flex;
  font-size: 0.32rem;
  justify-content: center;
  margin: 0.3rem 0;
}

.card-secret-num .card-num{
  font-size: 0.32rem;
  display: flex;
  align-items: center;
}
.card-secret-num .card-num span{
  font-weight: 800;
  font-size: 0.28rem;
  display: block;
  overflow: hidden;
  width: 50vw;
  margin-left: 0.1rem;
}

.card-secret-num .copy{
  margin-left: 0.2rem;
  color: #2A79FA;
}
.use-btn-wrap{ 
  text-align: center;
}
.use-btn{
  width: 1.89rem;
  height: 0.5rem;
  color: #333333 !important;
}

.instructions{
  width: 6.06rem;
  margin: 0.3rem auto;
  border-radius: 10px;
  padding: 0.12rem;
  background: #F1EFEF;
  text-align: left;
}
.text-show{
  white-space: nowrap; /* 确保文本在一行内显示 */
  overflow: hidden; /* 隐藏溢出的内容 */
  text-overflow: ellipsis;
  width: 6.86rem;
}
</style>